// =========================================================
// frontend/js/dashboard.js (V11.10 - Year Selector Fix)
// =========================================================
window.calculateStats = function() {
    var u = window.currentUser;
    if (!u || !u.commute) return null;
    // Nutzt das im Dropdown gewählte Jahr oder standardmäßig das aktuelle Jahr
    var targetYear = window.dashboardSelectedYear || new Date().getFullYear().toString();
    var events = window.events || [];
    var totalCO2 = 0;
    var totalMoney = 0;
    var totalTime = 0;
    var approvedCount = 0;
    for(var i = 0; i < events.length; i++){
        var e = events[i];
        var type = (e.type || "").toUpperCase();
        var isHO = type === 'HO' || type === 'HOMEOFFICE';
        if (e.userId === u.uid && e.date.startsWith(targetYear) && isHO && e.status === 'APPROVED') {
            var impact = window.calculateImpact(u.commute, 1, e.co2SavedAtBooking);
            totalCO2 += impact.co2Netto || 0;
            totalMoney += impact.money || 0;
            totalTime += impact.time || 0;
            approvedCount++;
        }
    }
    if (approvedCount === 0) return {
        hoDays: 0,
        savedTimeHours: 0,
        savedMoney: "0.00",
        savedCo2: "0.0",
        trees: "0.0"
    };
    return {
        hoDays: approvedCount,
        savedTimeHours: Math.round(totalTime),
        savedMoney: totalMoney.toFixed(2),
        savedCo2: totalCO2.toFixed(1),
        trees: (totalCO2 / 12.5).toFixed(1)
    };
};
window.saveUserTreeNode = async function(nodeId) {
    if (!window.currentUser || !window.updateUserInCloud) return;
    try {
        await window.updateUserInCloud(window.currentUser.uid, {
            nodeId: nodeId
        });
        window.currentUser.nodeId = nodeId;
        if (window.showToast) window.showToast("Team-Zugeh\xf6rigkeit erfolgreich gespeichert! \u2728");
        if (window.render) window.render();
    } catch (e) {
        console.error("Fehler beim Speichern der Struktur-Zuweisung:", e);
    }
};
window.renderDashboardHTML = function() {
    if (!window.currentUser) return `<div class="p-10 text-center text-slate-500 font-bold animate-pulse">Lade Dashboard...</div>`;
    const u = window.currentUser;
    // --- JAHRE EXTRAHIEREN ---
    const allMyEvents = (window.events || []).filter((e)=>e.userId === u.uid && e.status === 'APPROVED');
    let availableYears = [
        ...new Set(allMyEvents.map((e)=>e.date.substring(0, 4)))
    ].sort((a, b)=>b.localeCompare(a));
    const currentYearStr = new Date().getFullYear().toString();
    if (!availableYears.includes(currentYearStr)) availableYears.unshift(currentYearStr);
    if (!window.dashboardSelectedYear) window.dashboardSelectedYear = currentYearStr;
    const targetYear = window.dashboardSelectedYear;
    // -------------------------
    const stats = window.calculateStats();
    let flattenedTree = [];
    if (typeof window.getFlattenedTree === 'function' && window.orgStructure) flattenedTree = window.getFlattenedTree(window.orgStructure);
    let setupTodos = '';
    const isAdmin = [
        'OWNER',
        'ADMIN',
        'HR',
        'SUPERADMIN'
    ].includes(u.role);
    const hasAddress = !!(u.zip || u.postalcode || u.city || u.street || u.address?.zip);
    if (isAdmin && flattenedTree.length === 0) setupTodos += `
            <div class="bg-rose-50 border border-rose-200 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 shadow-sm animate-fadeIn">
                <div class="flex items-center gap-4">
                    <div class="w-12 h-12 bg-rose-100 text-rose-600 rounded-xl flex items-center justify-center shrink-0">
                        <i data-lucide="network" class="w-6 h-6"></i>
                    </div>
                    <div>
                        <h4 class="text-sm font-black text-rose-800 tracking-tight">Unternehmens-Struktur fehlt</h4>
                        <p class="text-xs text-rose-600/80 font-bold mt-0.5">Lege jetzt Standorte oder Teams an, damit deine Mitarbeiter sich zuordnen k\xf6nnen.</p>
                    </div>
                </div>
                <button onclick="window.activeView='settings'; window.activeSubView='tree'; localStorage.setItem('presenzo_view', 'settings'); localStorage.setItem('presenzo_subview', 'tree'); window.render();" class="bg-white text-rose-600 px-6 py-3 rounded-xl text-[10px] uppercase tracking-widest font-black shadow-sm border border-rose-200 hover:bg-rose-600 hover:text-white hover:border-rose-600 transition-all shrink-0">
                    Struktur anlegen &rarr;
                </button>
            </div>
        `;
    if (!hasAddress) setupTodos += `
            <div class="bg-amber-50 border border-amber-200 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 shadow-sm animate-fadeIn">
                <div class="flex items-center gap-4">
                    <div class="w-12 h-12 bg-amber-100 text-amber-600 rounded-xl flex items-center justify-center shrink-0">
                        <i data-lucide="home" class="w-6 h-6"></i>
                    </div>
                    <div>
                        <h4 class="text-sm font-black text-amber-800 tracking-tight">Hauptwohnsitz unvollst\xe4ndig</h4>
                        <p class="text-xs text-amber-600/80 font-bold mt-0.5">Bitte erg\xe4nze deine Adresse im Profil f\xfcr ein rechtlich sauberes Reporting.</p>
                    </div>
                </div>
                <button onclick="window.openMemberModal('${u.uid}')" class="bg-white text-amber-600 px-6 py-3 rounded-xl text-[10px] uppercase tracking-widest font-black shadow-sm border border-amber-200 hover:bg-amber-600 hover:text-white hover:border-amber-600 transition-all shrink-0">
                    Profil erg\xe4nzen
                </button>
            </div>
        `;
    const treeSelectorHTML = flattenedTree.length > 0 && !u.nodeId ? `
        <div class="bg-white px-5 py-4 rounded-2xl border border-orange-300 bg-orange-50/30 shadow-sm flex items-center gap-4 min-w-[280px] animate-fadeIn">
            <div class="w-10 h-10 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center shrink-0">
                <i data-lucide="network" class="w-5 h-5"></i>
            </div>
            <div class="flex-1">
                <p class="text-[9px] font-black text-orange-600 uppercase tracking-widest mb-0.5">\u{26A0}\u{FE0F} Bitte Team w\xe4hlen</p>
                <select onchange="window.saveUserTreeNode(this.value)" class="w-full bg-transparent font-bold text-sm text-slate-700 outline-none cursor-pointer">
                    <option value="">-- Jetzt zuordnen --</option>
                    ${flattenedTree.map((n)=>`<option value="${n.id}">${n.name}</option>`).join('')}
                </select>
            </div>
        </div>
    ` : '';
    if (!stats) return `
            <div class="p-8 lg:p-12 animate-fadeIn max-w-7xl mx-auto flex flex-col min-h-[70vh]">
                <div class="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-10">
                    <div>
                        <div class="flex items-center gap-4">
                            <h2 class="text-4xl font-black text-slate-800 tracking-tighter">Mein Dashboard</h2>
                        </div>
                        <p class="text-slate-400 font-bold uppercase tracking-widest text-[10px] mt-1">Setup erforderlich</p>
                    </div>
                    ${treeSelectorHTML}
                </div>

                ${setupTodos ? `<div class="mb-8">${setupTodos}</div>` : ''}

                <div class="flex-1 flex flex-col items-center justify-center">
                    <div class="bg-blue-50/50 border-2 border-dashed border-blue-200 rounded-[3rem] p-16 text-center max-w-3xl">
                        <div class="w-24 h-24 bg-white text-blue-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm">
                            <i data-lucide="leaf" class="w-10 h-10"></i>
                        </div>
                        <h3 class="text-2xl font-black text-slate-800 mb-3 tracking-tight">Dein Klimabeitrag fehlt noch!</h3>
                        <p class="text-slate-500 font-medium mb-8 max-w-md mx-auto">Hinterlege deinen t\xe4glichen Pendelweg, um zu sehen, wie viel Zeit, Geld und CO\u{2082} du durch deine Homeoffice-Tage bereits eingespart hast.</p>
                        <button onclick="window.activeView='settings'; window.activeSubView='commute'; localStorage.setItem('presenzo_view', 'settings'); localStorage.setItem('presenzo_subview', 'commute'); window.render();" class="bg-blue-600 text-white px-8 py-4 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-black transition-all shadow-xl shadow-blue-100">
                            Jetzt Pendelweg eintragen
                        </button>
                    </div>
                </div>
            </div>
        `;
    const prefs = u.dashboardPrefs || {};
    const showHoDays = prefs.showHoDays !== false;
    const showTimeSaved = prefs.showTimeSaved !== false;
    const showMoneySaved = prefs.showMoneySaved !== false;
    const showCo2Saved = prefs.showCo2Saved !== false;
    const showTrees = prefs.showTrees !== false;
    const moneyParts = stats.savedMoney.split('.');
    const euro = moneyParts[0] || "0";
    const cent = moneyParts[1] || "00";
    return `
        <div class="p-8 lg:p-12 animate-fadeIn max-w-7xl mx-auto">
            <div class="mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
                <div>
                    <div class="flex items-center gap-3">
                        <h2 class="text-4xl font-black text-slate-800 tracking-tighter">Mein Dashboard</h2>
                        <select onchange="window.dashboardSelectedYear = this.value; window.render();" class="bg-slate-100 text-blue-600 font-black text-xl px-3 py-1 rounded-xl border border-slate-200 outline-none cursor-pointer hover:bg-slate-200 transition-colors">
                            ${availableYears.map((y)=>`<option value="${y}" ${y === targetYear ? 'selected' : ''}>${y}</option>`).join('')}
                        </select>
                    </div>
                    <p class="text-slate-400 font-bold uppercase tracking-widest text-[10px] mt-2">Netto-Jahres\xfcbersicht ${targetYear}</p>
                </div>
                ${treeSelectorHTML}
            </div>

            ${setupTodos ? `<div class="mb-10">${setupTodos}</div>` : ''}

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12 animate-fadeIn">
                ${showHoDays ? `
                <div class="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm relative overflow-hidden group">
                    <div class="relative z-10">
                        <div class="w-12 h-12 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6">
                            <i data-lucide="home" class="w-6 h-6"></i>
                        </div>
                        <p class="text-blue-600/80 text-[10px] uppercase font-black tracking-widest mb-1">Homeoffice</p>
                        <div class="flex items-end gap-2">
                            <p class="text-5xl font-black text-slate-800 tracking-tighter">${stats.hoDays}</p>
                            <p class="text-sm font-bold text-slate-400 mb-2">Tage</p>
                        </div>
                    </div>
                </div>` : ''}

                ${showTimeSaved ? `
                <div class="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm relative overflow-hidden group">
                    <div class="relative z-10">
                        <div class="w-12 h-12 bg-indigo-100 text-indigo-600 rounded-2xl flex items-center justify-center mb-6">
                            <i data-lucide="clock" class="w-6 h-6"></i>
                        </div>
                        <p class="text-indigo-600/80 text-[10px] uppercase font-black tracking-widest mb-1">Zeit gespart</p>
                        <div class="flex items-end gap-2">
                            <p class="text-5xl font-black text-slate-800 tracking-tighter">${stats.savedTimeHours}</p>
                            <p class="text-sm font-bold text-slate-400 mb-2">Std.</p>
                        </div>
                    </div>
                </div>` : ''}

                ${showMoneySaved ? `
                <div class="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-sm relative overflow-hidden group">
                    <div class="relative z-10">
                        <div class="w-12 h-12 bg-amber-100 text-amber-600 rounded-2xl flex items-center justify-center mb-6">
                            <i data-lucide="wallet" class="w-6 h-6"></i>
                        </div>
                        <p class="text-amber-600/80 text-[10px] uppercase font-black tracking-widest mb-1">Geld gespart</p>
                        <div class="flex items-end gap-1">
                            <p class="text-5xl font-black text-slate-800 tracking-tighter">${euro}</p>
                            <p class="text-2xl font-black text-slate-400 mb-1">,${cent} \u{20AC}</p>
                        </div>
                    </div>
                </div>` : ''}

                ${showCo2Saved ? `
                <div class="bg-emerald-600 p-8 rounded-[2.5rem] shadow-xl shadow-emerald-100 relative overflow-hidden text-white group">
                    <div class="absolute -right-10 -bottom-10 opacity-20">
                        <i data-lucide="leaf" class="w-48 h-48"></i>
                    </div>
                    <div class="relative z-10">
                        <div class="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center mb-6">
                            <i data-lucide="wind" class="w-6 h-6 text-white"></i>
                        </div>
                        <p class="text-emerald-100 text-[10px] uppercase font-black tracking-widest mb-1">Netto CO\u{2082} Ersparnis</p>
                        <div class="flex items-end gap-2 mb-4">
                            <p class="text-5xl font-black tracking-tighter">${stats.savedCo2}</p>
                            <p class="text-sm font-bold text-emerald-200 mb-2">kg</p>
                        </div>
                        
                        ${showTrees ? `
                        <div class="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-xl text-[10px] font-black uppercase">
                            <i data-lucide="tree-pine" class="w-4 h-4 text-emerald-200"></i>
                            ~ ${stats.trees} B\xe4ume
                        </div>
                        ` : ''}
                    </div>
                </div>` : ''}
            </div>
        </div>
    `;
};

//# sourceMappingURL=frontend.429923af.js.map
